import NAME from "./constants";

export const getSigners = store => store[NAME].signers || [];
export const gettingsigners = store => store[NAME].gettingsigners;
export const loading = store => store[NAME].loading;
export const getDocs = store => store[NAME].docs;
export const getManagersEmployers = store => store[NAME].managersEmployers;
